// extracted by mini-css-extract-plugin
export default {"fullWidth":"Rn-z","image":"Sn-z","lazyLoadPicture":"Tn-z","lazyLoadSpinner":"Un-z","lazyLoadSpin":"Vn-z","lazyLoadImage":"Wn-z","hasStyledAspectRatio":"Xn-z"};